// import axios from "axios";

export default {
    state: {
        prices: null,
        appointments: []
    },
    getters: {
        appointment: (state) => (id) => {
            if(!id) return null;
            let index = state.appointments.findIndex(a => a.id == id);
            if(index != -1) return state.appointments[index];
            else return null;
        },
        appointmentType: (_, getters) => (id) => {
            console.log(id);
            let appointment = getters.appointment(id);
            if(appointment) return appointment.appointment_type;
            else return null;
        },
        appointmentTypeName: (_, getters) => (id) => {
            let appointment = getters.appointment(id);
            return appointment.appointment_type.name;
        },
        appointmentTypePrice: (_, getters) => (id) => {
            let appointment = getters.appointment(id);
            return appointment.appointment_type.price;
        },
        getExistingTreatments: (_, getters) => (id) => {
            let appointment = getters.appointment(id);
            let existingTreatments = [];
            if(!appointment) return existingTreatments;
            if(appointment.supplements.products.length > 0) existingTreatments.push({code: 'supp', price: getters.getTreatmentPrice({code: 'supp'}, id)})
            if(appointment.formulas.products.length > 0) existingTreatments.push({code: 'cmm', price: getters.getTreatmentPrice({code: 'cmm'}, id)})
            if(appointment.acu_points.filter(p => !p.auricular).length > 0) existingTreatments.push({code: 'acu', price: getters.getTreatmentPrice({code: 'acu'}, id)})
            if(appointment.acu_points.filter(p => p.auricular).length > 0) existingTreatments.push({code: 'acu-auri', price: getters.getTreatmentPrice({code: 'acu-auri'}, id)})
            appointment.other_treatments.forEach(t => {
                existingTreatments.push({code: t.module, price: getters.getTreatmentPrice(t, id)});
            });
            appointment.custom_treatments.forEach(t => {
                existingTreatments.push({id: t.id, name: t.name, price: getters.getTreatmentPrice(t, id)});
            });
            return existingTreatments;
        },
        getTreatmentPrice: (state, getters) => (treatment, id) => {
            let appointment = getters.appointment(id);
            if(appointment.appointment_type) {
                for(let i = 0; i < appointment.appointment_type.treatments.length; i++) {
                    if(treatment.code == appointment.appointment_type.treatments[i].code || treatment.id == appointment.appointment_type.treatments[i].id) return appointment.appointment_type.treatments[i].price;
                }
                return 'included'
            }
            else {
                for(let i = 0; i < state.prices.treatments.length; i++) {
                    if(treatment.code == state.prices.treatments[i].code || treatment.id == state.prices.treatments[i].id) return state.prices.treatments[i].price;
                }
                return null
            }
        },
        getExistingTests: (_, getters) => (id) => {
            let appointment = getters.appointment(id);
            let existingTests = [];
            if(!appointment) return existingTests;
            appointment.tests.forEach(t => {
                let code;
                if(t.module == 'tcm') code = t.kind;
                else code = t.module;
                existingTests.push({code: code, price: getters.getTestPrice(t, id)})
            });
            appointment.custom_tests.forEach(t => {
                existingTests.push({id: t.id, name: t.name, price: getters.getTestPrice(t, id)})
            });
            return existingTests;
        },
        getTestPrice: (state, getters) => (test, id) => {
            let appointment = getters.appointment(id);
            if(appointment.appointment_type) {
                for(let i = 0; i < appointment.appointment_type.tests.length; i++) {
                    if(test.code == appointment.appointment_type.tests[i].code || test.id == appointment.appointment_type.tests[i].id) return appointment.appointment_type.tests[i].price;
                }
                return 'included'
            }
            else {
                for(let i = 0; i < state.prices.tests.length; i++) {
                    if(test.code == state.prices.tests[i].code || test.id == state.prices.tests[i].id) return state.prices.tests[i].price;
                }
                return null
            }
        },
        appointmentPriceResult: (_, getters) => (id) => {
            let appointment = getters.appointment(id);
            let total = 0;
            if(appointment.appointment_type) total += appointment.appointment_type.price;
            getters.getExistingTests(id).forEach(t => {
                if(t.price && t.price != 'included') total += t.price;
            });
            getters.getExistingTreatments(id).forEach(t => {
                if(t.price && t.price != 'included') total += t.price;
            });
            return total;
        },
        appointmentPrice: (_, getters) => (id) => {
            let appointment = getters.appointment(id);
            if(appointment && appointment.price) return appointment.price;
            else return getters.appointmentPriceResult(id);
            //if(!state.appointment) return getters.appointmentPriceResult;
            //return state.appointment.price;
        }
    },
    mutations: {
        SET_APPOINTMENT(state, appointment) {
            state.appointments = [appointment];
        },
        SET_APPOINTMENTS(state, appointments) {
            state.appointments = appointments;
        },
        SET_PRICES(state, prices) {
            state.prices = prices;
        },
        SET_APPOINTMENT_PRICE(state, price) {
            state.appointments[0].price = price;
        },
        SET_TESTS(state, tests, custom_tests) {
            state.appointment.tests = tests;
            state.appointment.custom_tests = custom_tests;
        },
        SET_TREATMENTS(state, supplements, formulas, acu_points, other_treatments, custom_treatments) {
            state.appointment.supplements = supplements;
            state.appointment.formulas = formulas;
            state.appointment.acu_points = acu_points;
            state.appointment.other_treatments = other_treatments;
            state.appointment.custom_treatments = custom_treatments;
        }
    },
    actions: {
        SET_APPOINTMENT: ({commit}, appointment) => {
            commit('SET_APPOINTMENT', appointment);
        },
        SET_APPOINTMENTS: ({commit}, appointments) => {
            commit('SET_APPOINTMENTS', appointments);
        },
        SET_PRICES_INFO: ({commit}, info) => {
            if(info) commit('SET_PRICES', info);
        },
        SET_APPOINTMENT_PRICE: ({commit}, price) => {
            commit('SET_APPOINTMENT_PRICE', price);
        }
    }
}